module.exports = __webpack_public_path__ + "img/topicChildProducts.bb859371.webp";